"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require("babel-runtime/helpers/objectWithoutProperties");

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactstrap = require("reactstrap");

var _FAIcon = require("./../icon/FAIcon");

var _FAIcon2 = _interopRequireDefault(_FAIcon);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TagItem = function (_React$Component) {
    (0, _inherits3.default)(TagItem, _React$Component);

    function TagItem() {
        (0, _classCallCheck3.default)(this, TagItem);
        return (0, _possibleConstructorReturn3.default)(this, (TagItem.__proto__ || (0, _getPrototypeOf2.default)(TagItem)).apply(this, arguments));
    }

    (0, _createClass3.default)(TagItem, [{
        key: "render",
        value: function render() {
            var _props = this.props,
                onRemove = _props.onRemove,
                children = _props.children,
                className = _props.className,
                otherProps = (0, _objectWithoutProperties3.default)(_props, ["onRemove", "children", "className"]);


            className = (0, _classnames2.default)('tag-item', className);

            return _react2.default.createElement(
                "div",
                (0, _extends3.default)({ className: className }, otherProps),
                _react2.default.createElement(
                    "div",
                    { className: "tag-content" },
                    children
                ),
                _react2.default.createElement(
                    _reactstrap.Button,
                    { type: "button", className: "tag-action", color: "action", onClick: onRemove },
                    _react2.default.createElement(_FAIcon2.default, { icon: "times" })
                )
            );
        }
    }]);
    return TagItem;
}(_react2.default.Component);

TagItem.PropTypes = {
    className: _react2.default.PropTypes.string,
    onRemove: _react2.default.PropTypes.func.isRequired
};
exports.default = TagItem;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvdGFnL1RhZ0l0ZW0uanN4Il0sIm5hbWVzIjpbIlRhZ0l0ZW0iLCJwcm9wcyIsIm9uUmVtb3ZlIiwiY2hpbGRyZW4iLCJjbGFzc05hbWUiLCJvdGhlclByb3BzIiwiUmVhY3QiLCJDb21wb25lbnQiLCJQcm9wVHlwZXMiLCJzdHJpbmciLCJmdW5jIiwiaXNSZXF1aXJlZCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOzs7O0FBQ0E7O0FBQ0E7Ozs7QUFDQTs7Ozs7O0lBRXFCQSxPOzs7Ozs7Ozs7O2lDQU1SO0FBQUEseUJBQ2dELEtBQUtDLEtBRHJEO0FBQUEsZ0JBQ0FDLFFBREEsVUFDQUEsUUFEQTtBQUFBLGdCQUNVQyxRQURWLFVBQ1VBLFFBRFY7QUFBQSxnQkFDb0JDLFNBRHBCLFVBQ29CQSxTQURwQjtBQUFBLGdCQUNrQ0MsVUFEbEM7OztBQUdMRCx3QkFBWSwwQkFBVyxVQUFYLEVBQXVCQSxTQUF2QixDQUFaOztBQUVBLG1CQUNJO0FBQUE7QUFBQSx5Q0FBSyxXQUFXQSxTQUFoQixJQUErQkMsVUFBL0I7QUFDSTtBQUFBO0FBQUEsc0JBQUssV0FBVSxhQUFmO0FBQ0tGO0FBREwsaUJBREo7QUFJSTtBQUFDLHNDQUFEO0FBQUEsc0JBQVEsTUFBSyxRQUFiLEVBQXNCLFdBQVUsWUFBaEMsRUFBNkMsT0FBTSxRQUFuRCxFQUE0RCxTQUFTRCxRQUFyRTtBQUErRSxrREFBQyxnQkFBRCxJQUFNLE1BQUssT0FBWDtBQUEvRTtBQUpKLGFBREo7QUFRSDs7O0VBbkJnQ0ksZ0JBQU1DLFM7O0FBQXRCUCxPLENBQ1ZRLFMsR0FBWTtBQUNmSixlQUFXRSxnQkFBTUUsU0FBTixDQUFnQkMsTUFEWjtBQUVmUCxjQUFVSSxnQkFBTUUsU0FBTixDQUFnQkUsSUFBaEIsQ0FBcUJDO0FBRmhCLEM7a0JBREZYLE8iLCJmaWxlIjoiVGFnSXRlbS5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQge0J1dHRvbn0gZnJvbSBcInJlYWN0c3RyYXBcIjtcbmltcG9ydCBJY29uIGZyb20gXCIuLy4uL2ljb24vRkFJY29uXCI7XG5pbXBvcnQgY2xhc3NOYW1lcyBmcm9tICdjbGFzc25hbWVzJztcblxuZXhwb3J0IGRlZmF1bHQgY2xhc3MgVGFnSXRlbSBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gICAgc3RhdGljIFByb3BUeXBlcyA9IHtcbiAgICAgICAgY2xhc3NOYW1lOiBSZWFjdC5Qcm9wVHlwZXMuc3RyaW5nLFxuICAgICAgICBvblJlbW92ZTogUmVhY3QuUHJvcFR5cGVzLmZ1bmMuaXNSZXF1aXJlZCxcbiAgICB9O1xuXG4gICAgcmVuZGVyKCkge1xuICAgICAgICBsZXQge29uUmVtb3ZlLCBjaGlsZHJlbiwgY2xhc3NOYW1lLCAuLi5vdGhlclByb3BzfSA9IHRoaXMucHJvcHM7XG5cbiAgICAgICAgY2xhc3NOYW1lID0gY2xhc3NOYW1lcygndGFnLWl0ZW0nLCBjbGFzc05hbWUpO1xuXG4gICAgICAgIHJldHVybiAoXG4gICAgICAgICAgICA8ZGl2IGNsYXNzTmFtZT17Y2xhc3NOYW1lfSB7Li4ub3RoZXJQcm9wc30+XG4gICAgICAgICAgICAgICAgPGRpdiBjbGFzc05hbWU9XCJ0YWctY29udGVudFwiPlxuICAgICAgICAgICAgICAgICAgICB7Y2hpbGRyZW59XG4gICAgICAgICAgICAgICAgPC9kaXY+XG4gICAgICAgICAgICAgICAgPEJ1dHRvbiB0eXBlPVwiYnV0dG9uXCIgY2xhc3NOYW1lPVwidGFnLWFjdGlvblwiIGNvbG9yPVwiYWN0aW9uXCIgb25DbGljaz17b25SZW1vdmV9PjxJY29uIGljb249XCJ0aW1lc1wiLz48L0J1dHRvbj5cbiAgICAgICAgICAgIDwvZGl2PlxuICAgICAgICApO1xuICAgIH1cbn1cblxuIl19